import React from 'react';
import { View, type ViewStyle } from 'react-native';

import { ConnectAccountManagement } from '@stripe/react-connect-js';

export interface AccountManagementProps {
  /** Mesma assinatura do par nativo (`account-management.tsx`). A altura segue o conteúdo. */
  style?: ViewStyle;
}

/**
 * Gestão da conta (`account-management`, T4.4): trocar banco, corrigir
 * dados — em Configurar recebimento (T6.4). Precisa estar dentro de um
 * `StripeConnectProvider`.
 */
export function AccountManagement({ style }: AccountManagementProps) {
  return (
    <View style={style}>
      <ConnectAccountManagement />
    </View>
  );
}
